import { isTabbable } from './is-tabbable';

/**
 * Sets `tabindex="0"` attribute to the given element if it is not already tabbable
 * @param element
 */
export function makeTabbable(element: Element) {
  if (!isTabbable(element)) {
    element.setAttribute('tabindex', '0');
  }
}
